module.exports = __webpack_public_path__ + "img/fi-rr-network-cloud.321191a7.svg";